import { BetaFeatureOnly } from "@/components/beta-feature";
import { useWorkbookForwardState } from "@/hooks/use-workbook-forward-state";
import { AlertTriangle, Loader2 } from "lucide-react";

// ============================================
// IxdForwardingChip
// IXD 태깅이 도는 중이거나 죽었을 때 툴바에 뜨는 상태 표시.
//
// 버튼처럼 보이지 않게 둔다 — 누를 것은 없고 알려줄 것만 있다. 지금 표에
// 보이는 태그가 최종본이 아니라는 사실만 전한다.
//
// 실패는 원인까지 붙인다(tooltip). 베타 사용자는 팀 내부라 원문 예외가
// 그대로 도움이 되고, 이게 없으면 "왜 태그가 없지"에서 멈춘다.
//
// 베타 게이트가 두 겹이다: 훅이 조회 자체를 막아 비베타는 요청도 안 나가고,
// BetaFeatureOnly 가 렌더를 막는다. 한 겹이 뚫려도 새지 않게.
// ============================================

export const IxdForwardingChip = ({
  workbookId,
}: {
  workbookId: string | null;
}) => {
  const state = useWorkbookForwardState(workbookId);

  return (
    <BetaFeatureOnly when={state.kind !== "idle"}>
      {state.kind === "failed" ? (
        <span
          title={state.error ?? undefined}
          className="flex items-center gap-[6px] px-[8px] label-1-normal-medium text-status-negative"
        >
          <AlertTriangle className="w-4 h-4" />
          포워드 실패
        </span>
      ) : (
        <span className="flex items-center gap-[6px] px-[8px] label-1-normal-medium text-label-neutral">
          <Loader2 className="w-4 h-4 animate-spin" />
          포워드 중...
        </span>
      )}
    </BetaFeatureOnly>
  );
};
